// Copyright 2020 Sorama B.V.

import { PLATFORM } from "aurelia-framework";
import { CanvasMediaObjectLinkDTO, LinkedMediaObjectType, VideoDTO } from "datatypes/SoramaWebApi";
import { ICanvasMediaObjectLinkRepository } from "repositories/CanvasMediaObjectLinkRepository";
import { BoundingBox, IComposableParent } from "./../ComposableCanvas";
import { IComposableMediaObjectAction } from "./ComposableMediaObject";
import { ComposableTwoDimensionalMediaObject } from "./ComposableTwoDimensionalMediaObject";

export class ComposableVideoMediaObject extends ComposableTwoDimensionalMediaObject {
    public readonly template: string = PLATFORM.moduleName("controls/composable-canvas/templates/VideoTemplate.html");
    public readonly additionalActions: IComposableMediaObjectAction[] = [];

    public get mediaObjectType(): LinkedMediaObjectType {
        return LinkedMediaObjectType.Video;
    }

    protected source: string;

    constructor(
        linkRepository: ICanvasMediaObjectLinkRepository,
        parent: IComposableParent,
        link: CanvasMediaObjectLinkDTO,
        initialSize: BoundingBox,
        source: string | Promise<string>,
        mediaObject: VideoDTO
    ) {
        super(linkRepository, parent, link, initialSize, mediaObject);

        if (!source) {
            return;
        }

        if (typeof source == "string") {
            this.source = source;
        } else {
            this.busy = true;
            (<Promise<string>>source)
                .then((x) => (this.source = x))
                .catch((x) => {
                    // Broken image, UI will show a placeholder instead
                })
                .then(() => {
                    this.busy = false;
                });
        }
    }
}
